export const environment = {
  production: true,
  apiUrl: '/api',
  backendUrl: 'http://backend.geekeno-prod.svc.cluster.local',
  mapsApiKey: 'AIzaSyBuM9xMKl0Be2wBLO6IJXYyTYCDYuZ-6nU',
};
